import React from 'react';
import { CerebroBreadcrumb, CerebroPageContainer, CerebroSecondaryButton, CerebroText } from '../../shared/components';
import { LenderRequestCallForm } from '../../shared/components/Layout/LenderRequestCallForm';
import { useDataRoomLenderCallQuery, useGetDataRoomUserByUserQuery } from '../../shared/hooks';
import { ActiveDataRoomUser, CurrentUser, DataRoomCall } from '../../shared/models';
import { CallForm } from './CallForm';
import { LenderCallsDisplay } from './LenderCallsDisplay';

interface LenderCallsPageProps {
	dataRoomGuid: string | undefined;
	currentUser: CurrentUser;
}

export const LenderCallsPage: React.FC<LenderCallsPageProps> = ({ dataRoomGuid, currentUser }) => {
	const roomUserQuery = useGetDataRoomUserByUserQuery(dataRoomGuid, currentUser.userGuid, true);
	const callsQuery = useDataRoomLenderCallQuery(dataRoomGuid, roomUserQuery.data?.bankDealProfileGuid, {
		enabled: roomUserQuery.isSuccess,
		retry: false,
	});

	const [scheduleCall, setScheduleCall] = React.useState<ActiveDataRoomUser | null | undefined>(null);
	const [callEdit, setCallEdit] = React.useState<DataRoomCall | null>(null);

	const closeDrawersAndDialogs = () => {
		setScheduleCall(null);
		setCallEdit(null);
	};

	return (
		<CerebroPageContainer maxWidth="100%">
			<CerebroBreadcrumb>Call Scheduling</CerebroBreadcrumb>

			<CerebroText variant="small" sx={{ marginBottom: 2 }}>
				Use this page to schedule a call with the borrower. You can request a call and view details on
				previously requested calls.
			</CerebroText>
			<CerebroSecondaryButton onClick={() => setScheduleCall(roomUserQuery.data)} sx={{ marginBottom: 2 }}>
				Schedule Call
			</CerebroSecondaryButton>

			<LenderCallsDisplay
				dataRoomGuid={dataRoomGuid}
				isLoading={callsQuery.isLoading || roomUserQuery.isLoading}
				user={roomUserQuery.data}
				calls={callsQuery.data}
				onEdit={setCallEdit}
			/>

			<LenderRequestCallForm
				dataRoomGuid={dataRoomGuid}
				activeUser={scheduleCall}
				close={closeDrawersAndDialogs}
			/>
			<CallForm dataRoomGuid={dataRoomGuid} call={callEdit} close={closeDrawersAndDialogs} />
		</CerebroPageContainer>
	);
};
